import { render, staticRenderFns } from "./dialogWd.vue?vue&type=template&id=2f60f8ae&scoped=true"
import script from "./dialogWd.vue?vue&type=script&lang=js"
export * from "./dialogWd.vue?vue&type=script&lang=js"
import style0 from "./dialogWd.vue?vue&type=style&index=0&id=2f60f8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60f8ae",
  null
  
)

export default component.exports